import React from "react";

/**
 * HintPage component for displaying hint information and navigation
 *
 * @param {Object} props
 * @param {string} props.message - The hint message to display
 * @param {string} props.image - URL of the hint image
 * @param {Function} props.onAnswerInput - Function to handle answer input button click
 * @param {Function} props.onBack - Function to handle back button click
 */

import characterImage from "../../assets/images/anime-character.png";

const HintPage = ({ hints, onAnswerInput, onBack }) => {
  return (
    <div className="flex flex-col items-start justify-between h-full py-6 px-5">
      {/* Top message bubble */}
      {hints.map((hint, index) => (
        <div key={index} className="mb-4">
          <div className="flex items-start  gap-3">
            {/* Avatar outside of bubble - show character image for feedback too */}
            <img
              src={characterImage}
              alt="Character"
              className="w-14 h-14 rounded-full flex-shrink-0 mt-1 border-2 border-white shadow-md"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = characterImage;
              }}
            />
            <div className="flex flex-col gap-2 mt-1">
              <div className="bg-purple-500 text-white  rounded-tr-xl rounded-tl-xl rounded-br-xl mr-12 p-4">
                <p className="whitespace-pre-wrap text-base">{hint.text}</p>
              </div>
              {hint.imageUrl && (
                <img
                  src={hint.imageUrl}
                  alt="手がかりの画像"
                  className="w-[340px] h-[200px] object-cover rounded-xl shadow-md "
                />
              )}
            </div>
          </div>
          <div className="flex items-start  gap-3 mt-2">
            {/* Avatar outside of bubble - show character image for feedback too */}
            <img
              src={characterImage}
              alt="Character"
              className="w-14 h-14 rounded-full flex-shrink-0 mt-1 border-2 border-white shadow-md"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = characterImage;
              }}
            />
            <div className="flex flex-col gap-2 mt-1">
              <div className="bg-purple-500 text-white  rounded-tr-xl rounded-tl-xl rounded-br-xl mr-12 p-4">
                <p className="whitespace-pre-wrap text-base">
                  {hint.additionalText}
                </p>
              </div>
            </div>
          </div>
        </div>
      ))}

      <div className="fixed bottom-16 left-0 right-0 px-4 flex justify-center space-x-4 z-10">
        <button
          onClick={onAnswerInput}
          className="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-3 px-8 rounded-full shadow-md text-lg"
          style={{
            boxShadow:
              "0 4px 6px rgba(0, 0, 0, 0.1), 0 0 15px rgba(63, 81, 181, 0.3)",
            fontFamily: "Hiragino Kaku Gothic Pro, sans-serif",
          }}
        >
          答えを入力
        </button>
        <button
          onClick={onBack}
          className="bg-amber-500 hover:bg-amber-600 text-white font-semibold py-3 px-8 rounded-full shadow-md text-lg"
          style={{
            boxShadow:
              "0 4px 6px rgba(0, 0, 0, 0.1), 0 0 15px rgba(255, 193, 7, 0.3)",
            fontFamily: "Hiragino Kaku Gothic Pro, sans-serif",
          }}
        >
          前に戻る
        </button>
      </div>
    </div>
  );
};

export default HintPage;
